import { put, select } from 'redux-saga/effects'

import {
  type DashboardActions,
  FolderAccessRequestAction,
  InternalFolderActions as Internal,
} from '../../actions'
import { selectFolder } from '../../selectors/selectFolder'
import type { WorkspaceItem } from '../../types'

export function* updateVisibility({
  payload: { workspaceId, id, visibility },
}: ReturnType<typeof DashboardActions.folders.updateVisibility>) {
  const folder: WorkspaceItem | null = yield select(
    selectFolder(workspaceId, id)
  )

  if (!folder) {
    return
  }

  yield put(
    Internal.update({
      workspaceId,
      id,
      data: {
        visibility,
      },
    })
  )

  yield put(
    FolderAccessRequestAction({
      workspaceId,
      id,
      visibility,
      members: folder.members,
    })
  )
}
